/**
 * @flow
 * @relayHash 7761e535d1910b01edb77aa64f04bffb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PrintProductContent_product$ref = any;
export type PrintProductQueryVariables = {|
  id: string,
|};
export type PrintProductQueryResponse = {|
  +product: ?{|
    +$fragmentRefs: PrintProductContent_product$ref,
  |},
|};
*/


/*
query PrintProductQuery(
  $id: ID!
) {
  product: node(id: $id) {
    __typename
    ...PrintProductContent_product
    id
  }
}

fragment PrintProductContent_product on Product {
  id
  name
  description
  files {
    edges {
      node {
        url
      }
    }
  }
  category {
    name
    family {
      name
      id
    }
    id
  }
  ...ProductCharacteristics_product
}

fragment ProductCharacteristics_product on Product {
  category {
    characteristicKeys {
      edges {
        node {
          key
          id
        }
      }
    }
    id
  }
  characteristics {
    edges {
      node {
        key {
          key
          id
        }
        value
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "key",
    "args": null,
    "storageKey": null
  },
  v2
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "PrintProductQuery",
  "id": null,
  "text": "query PrintProductQuery(\n  $id: ID!\n) {\n  product: node(id: $id) {\n    __typename\n    ...PrintProductContent_product\n    id\n  }\n}\n\nfragment PrintProductContent_product on Product {\n  id\n  name\n  description\n  files {\n    edges {\n      node {\n        url\n      }\n    }\n  }\n  category {\n    name\n    family {\n      name\n      id\n    }\n    id\n  }\n  ...ProductCharacteristics_product\n}\n\nfragment ProductCharacteristics_product on Product {\n  category {\n    characteristicKeys {\n      edges {\n        node {\n          key\n          id\n        }\n      }\n    }\n    id\n  }\n  characteristics {\n    edges {\n      node {\n        key {\n          key\n          id\n        }\n        value\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PrintProductQuery",
    "type": "LarkSeedsAPI",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "product",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PrintProductContent_product",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PrintProductQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "product",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          v2,
          {
            "kind": "InlineFragment",
            "type": "Product",
            "selections": [
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "files",
                "storageKey": null,
                "args": null,
                "concreteType": "FileConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FileEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "File",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "Category",
                "plural": false,
                "selections": [
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "family",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Family",
                    "plural": false,
                    "selections": [
                      v3,
                      v2
                    ]
                  },
                  v2,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "characteristicKeys",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CharacteristicKeyConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CharacteristicKeyEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CharacteristicKey",
                            "plural": false,
                            "selections": v4
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "characteristics",
                "storageKey": null,
                "args": null,
                "concreteType": "CharacteristicValueConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CharacteristicValueEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CharacteristicValue",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "key",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CharacteristicKey",
                            "plural": false,
                            "selections": v4
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "value",
                            "args": null,
                            "storageKey": null
                          },
                          v2
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'ff6ad5495548d3b6b5efe54307e4d749';
module.exports = node;



// WEBPACK FOOTER //
// ./src/views/PrintProduct/__generated__/PrintProductQuery.graphql.js